import {
  StudioResourceTypeEnum,
  proStudioUrqlGql as urqlGql,
} from '@pypestream/api-services';

import {
  ProStudioContext,
  ProStudioEvents,
  ResourceLibItem,
} from '../prostudio.xstate.types';
import { throwErrorWithId } from '../../../../../utils/errors';

export const loadResourceLibraryData = async (
  _ctx: ProStudioContext,
  _event: ProStudioEvents
): Promise<{
  resourceLibraryData: ResourceLibItem[];
}> => {
  const { data, error } = await urqlGql.getStudioResources();

  if (error) {
    throwErrorWithId('Error fetching studio resources');
    return { resourceLibraryData: [] };
  }

  const resourceLibraryData: ResourceLibItem[] = (
    data?.admin_?.studioResources || []
  )
    ?.sort((a, b) => {
      const isAAction = a?.type === StudioResourceTypeEnum.ActionNode;
      const isBAction = b?.type === StudioResourceTypeEnum.ActionNode;

      if (isAAction && !isBAction) return 1;
      if (isBAction && !isAAction) return -1;
      return 0;
    })
    .map((item) => {
      return {
        ...item,
        data: item.nodes?.map(({ studioResourceId, ...node }) => node),
        nodes:
          item.type === StudioResourceTypeEnum.MicroAgent
            ? item.nodes?.length
            : undefined,
      };
    }) as ResourceLibItem[];

  return { resourceLibraryData };
};
